

export default class Element {

    type=''
    nom=''
    slug=''
    icone=''
    color='#FF0000'
    carac=[]
    lieu=[]

    constructor(type) {
        this.type=type
        //icone par defaut 'OBJ'

        if(type==='PNJ'){
            this.icone='smile'
        }
        else if(type==='OBJ'){
            this.icone='cog'
        }
        else if(type==='BAD'){
            this.icone='ghost'
        }
        else if(type==='DEC'){
            this.icone='cube'
        }

    }


}